import angular from "angular";
/**
 * adds a <label> Element with its placeholder for the given element
 */

const PlaceHolderClickDirective = function ($animate) {
    return {
        restrict: 'A',
        scope: { placeholderclick: '@', placeholder: '@' },

        link: function ($scope, element) {

            element.isElementActive = function () {
                var activeElement = angular.element(document.activeElement);
                var active = false;
                if (activeElement[ 0 ] && element[ 0 ]) {
                    active = activeElement[ 0 ] === element[ 0 ];
                }
                return active;
            };

            if (!$scope.internalPlaceholder) {
                $scope.internalPlaceholder = $scope.placeholder;
            }
            if (!$scope.internalPlaceholder) {
                return;
            }

            var hideOverlay = function () {
                if ($scope.overlay && element.val() === '') {
                    $animate.removeClass($scope.overlay, 'on').then(function () {
                        $scope.overlay.hide();
                    });
                    element.attr('placeholder', $scope.internalPlaceholder);
                }
            };

            var showOverlay = function () {
                var parentElement = element.parent();
                if (!$scope.overlay) {
                    $scope.overlay = angular.element('<label class="overlay">' + $scope.internalPlaceholder + '</label>');
                    var inputId = element.attr('id');
                    if (inputId) {
                        $scope.overlay.attr('for', inputId);
                    }
                    $scope.overlay.hide();
                    $scope.overlay.appendTo(parentElement);
                }

                if (element.val() === '' && !element.isElementActive()) {
                    hideOverlay();
                } else {
                    element.attr('placeholder', '');
                    $scope.overlay.show();
                    $animate.addClass($scope.overlay, 'on');
                }
            };

            // hide overlay if value is empty (maybe other source than input)
            $scope.$watch(
                function () {
                    return element.val();
                },
                function (newVal, oldVal) {
                    if (newVal === '' && oldVal !== '' && !element.isElementActive()) {
                        hideOverlay();
                    } else if (newVal !== '') {
                        showOverlay();
                    }
                }
            );

            element.on('select', showOverlay);
            element.on('focus', showOverlay);
            element.on('change', showOverlay);
            element.on('touchstart', showOverlay);

            element.on('blur', hideOverlay);
        }
    };
};

export default PlaceHolderClickDirective;